import {
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {EditPage} from "./pages/EditPage.tsx";
import {rbacActions} from "../../config/rbac/actions.ts";
import {RestrictedRouteElement} from "../../components/RestrictedRouteElement.tsx";

import {AddPage as AddSubscriptionItemPage} from '../subscription-items/pages/AddPage'
import {EditPage as EditSubscriptionItemPage} from '../subscription-items/pages/EditPage'


export const SubscriptionsLayout = () => {


    return (
        <Routes>

            <Route
                path='/'
                element={<RestrictedRouteElement rbacAction={rbacActions.ListSubscriptions}>
                    <IndexPage/></RestrictedRouteElement>}
            />

            <Route
                path=':id'
                element={<RestrictedRouteElement rbacAction={rbacActions.GetSubscription}>
                    <EditPage/></RestrictedRouteElement>}
            />

            <Route
                path=':id/subscription-items/add'
                element={<RestrictedRouteElement rbacAction={rbacActions.CreateSubscriptionItem}>
                    <AddSubscriptionItemPage/></RestrictedRouteElement>}
            />

            <Route
                path=':id/subscription-items/:subscriptionItemId'
                element={<RestrictedRouteElement rbacAction={rbacActions.UpdateSubscriptionItem}>
                    <EditSubscriptionItemPage/></RestrictedRouteElement>}
            />

        </Routes>
    );
};
